<template>
  <div>
    <DealerBanner />
    <DownloadCaseBanner />
    <CustomerUserNav
      :showAdmin="showAdmin"
      :showCaseLibrary="showCaseLibrary"
      :navTabsOptional="navTabsOptional"
      v-if="!user.isInternalUser && !user.isDealerUser"
    />
    <DealerUserNav
      :dealerViewingUser="dealerViewingUser"
      :showDealerMyUsers="showDealerMyUsers"
      :navTabsOptional="navTabsOptional"
      v-if="user.isDealerUser"
    />
    <DealerCCBanner />
    <InternalUserNav
      v-if="user.isInternalUser"
      :showMyUsers="hasCreateEditInternalUsersPermission"
      :navTabsOptional="navTabsOptional"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import CustomerUserNav from './navigation/CustomerUserNav.vue'
import DealerUserNav from './navigation/DealerUserNav.vue'
import InternalUserNav from './navigation/InternalUserNav.vue'
import DealerBanner from './DealerBanner.vue'
import DealerCCBanner from '@/components/banners/DealerCCBanner.vue'
import DownloadCaseBanner from './DownloadCaseBanner.vue'

import { mapState, mapGetters } from 'vuex'
import * as Permissions from '@/constants/permissions.js'

export default defineComponent({
  name: 'Header',
  components: {
    DealerBanner,
    DealerCCBanner,
    DownloadCaseBanner,
    CustomerUserNav,
    DealerUserNav,
    InternalUserNav,
  },
  data() {
    return {
      tab: '',
    }
  },
  computed: {
    ...mapState('Security', ['user', 'dealerViewingUser', 'isLoggedIn']),
    ...mapGetters('Security', ['hasPermission']),
    hasCreateEditInternalUsersPermission() {
      return this.hasPermission(Permissions.CREATE_EDIT_INTERNAL_USERS)
    },
    showCaseLibrary() {
      return (
        this.hasPermission(Permissions.VIEW_CASE) ||
        this.hasPermission(Permissions.CREATE_EDIT_CASE)
      )
    },
    showAdmin() {
      return this.hasPermission(Permissions.CREATE_EDIT_CUSTOMER_USERS)
    },
    showDealerMyUsers() {
      return this.hasPermission(Permissions.CREATE_EDIT_DEALER_USERS)
    },
    navTabsOptional() {
      const route = this.$route.name
      switch (route) {
        case 'Profile':
          return true
        case 'NotificationsList':
          return true
        case 'Notification Settings':
          return true
        case 'Help':
          return true
        default:
          return false
      }
    },
  },
})
</script>

<style lang="scss">
.header {
  .icon-hover {
    &:hover {
      cursor: pointer;
    }
  }
  padding-right: 2rem;
  @media screen and (max-width: 600px) {
    padding-right: 0rem !important;
  }
  &.v-card {
    min-width: 100%;
    background-color: black !important;
  }
  .v-app-bar {
    padding-left: 2rem;
    @media screen and (max-width: 600px) {
      padding-left: 0.5rem !important;
    }
    @media screen and (min-width: $large) {
    }
    @media screen and (min-width: $extra-large) {
    }
  }
  .toolbar-logo {
    img {
      vertical-align: middle;
      @media screen and (min-width: 600px) {
        padding-right: 10px;
      }
    }
  }
  .v-tab {
    height: 100%;
    padding-left: 4px;
    padding-right: 8px;
    margin-left: 0px !important;
    margin-right: 8px;
  }
  i {
    height: 18px;
    width: 18px;
    margin-right: 0.25rem;
  }
  .gear-icon-tweak {
    height: 17px;
  }
  .v-tab--active.v-tab.v-tab {
    color: white;
  }
  .v-toolbar__title {
    overflow: unset;
    vertical-align: middle;
  }
  .nav-active {
    background-color: #404040;
  }
  .v-toolbar__content,
  .v-toolbar__extension {
    @media screen and (min-width: 600px) {
      padding-right: 5px !important;
    }
  }
  .v-toolbar__content {
    height: 6.5vh !important;
    padding-left: 0;
  }
  .v-slide-group__prev .v-slide-group__prev--disabled {
    max-width: 0 !important;
  }
  .v-slide-group__prev {
    display: none !important;
  }
}
</style>
